import { g as global$1 } from './global.js';
import { p as path$1 } from './path.js';

var global = global$1;
var path = path$1;

var getBuiltInPrototypeMethod = function (CONSTRUCTOR, METHOD) {
  var Namespace = path[CONSTRUCTOR + 'Prototype'];
  var pureMethod = Namespace && Namespace[METHOD];
  if (pureMethod) return pureMethod;
  var NativeConstructor = global[CONSTRUCTOR];
  var NativePrototype = NativeConstructor && NativeConstructor.prototype;
  return NativePrototype && NativePrototype[METHOD];
};

export { getBuiltInPrototypeMethod as g };
//# sourceMappingURL=get-built-in-prototype-method.js.map
